module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/rotate_UB.4b9079c4.svg";